<template>
  <transition name="fade">
    <div class="drainage" v-if="drainagePopVisible">
      <div class="drainage_wrapper" @click.native="closePop"></div>
      <div class="drainage_content">
        <div class="drainage_card">
          <p class="drainage_info">{{drainageValue.toolTips}}</p>
          <img class="drainage_avatar" :src="drainageValue.orangePicture" />
          <p class="drainage_name">{{drainageValue.orangeName}}</p>
          <p class="drainage_value">微信号：{{drainageValue.orangeWeChat}}</p>
          <img class="drainage_qrcode" :src="drainageValue.weChatCode" />
          <p class="drainage_more">微信扫描二维码添加</p>
        </div>
        <div class="drainage_close_btn">
          <vui-ico
            class="ico ibang-close broadcast-close"
            :w="24"
            :lh="36"
            @click.native="closePop"
          ></vui-ico>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('app', ['dialogConfig', 'drainagePopVisible']),
    drainageValue () {
      return this.dialogConfig || {}
    },
  },
  methods: {
    closePop () {
      this.$store.commit('app/setDrainagePopVisible', { flag: false })
    },
  },
}
</script>
<style lang="scss" scoped>
.drainage {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 99;
  .drainage_wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.5;
  }
  .drainage_content {
    position: absolute;
    width: 300px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    .drainage_card {
      width: 100%;
      border-radius: 15px;
      background: #fff;
      padding: 24px 48px;
      line-height: 24px;
      .drainage_info {
        margin-bottom: 20px;
      }
      .drainage_avatar {
        width: 56px;
        height: 56px;
        margin-bottom: 10px;
      }
      .drainage_value {
        color: #959595;
        margin-bottom: 10px;
      }
      .drainage_qrcode {
        height: 100px;
        width: 100px;
        margin-bottom: 10px;
      }
      .drainage_more {
        font-size: 14px;
        color: #959595;
      }
    }
    .drainage_close_btn {
      margin: 40px auto 0;
      width: 36px;
      height: 36px;
      border-radius: 18px;
      background: #000;
      cursor: pointer;
      i {
        color: #fff;
      }
    }
  }
}
</style>
